module.exports = __webpack_public_path__ + "static/media/pr.5294d724.svg";